<template>
<div class="comment-score">
    <div class="item" v-for="(item,index) in txtList" :key="index">
        <div class="txt">{{item}}</div>
        <div class="score">
            <div class="lf" :class="{active:(index*2+1)*0.5<=score}" :title="(index*2+1)*0.5" @click="handleScore(index*2+1)"></div>
            <div class="lr" :class="{active:(index*2+2)*0.5<=score}" :title="(index*2+2)*0.5" @click="handleScore(index*2+2)"></div>
        </div>
    </div>
    

</div>
</template>
<script>
export default {
    name:'SelectCommentScore',
    data(){
        return {
            txtList:['很糟糕','较差','一般','还可以','很棒'],
            score:0,
        }
    },
    methods:{
        handleScore(index){
            this.score = index*0.5;
         
        }
    }
}
</script>
<style lang="scss" scoped>
.comment-score{
    display: flex;
    .item{
        margin-right: 20px; display: flex; align-items: center; flex-direction: column;
        .txt{font-size: 14px; line-height: 30px; color: #333;}
        .score{
            position: relative;
            width: 26px; height: 26px; background: url('@/assets/images/info/comment-star.png') no-repeat center top ; background-size: 26px;
            .lf,.lr{ position: absolute; top: 0; width: 50%; height: 100%; cursor: pointer;}
            .lf{left: 0;}
            .lr{right: 0;}
            .lr.active,.lf.active{
                background: url('@/assets/images/info/comment-star.png') no-repeat ; background-size:26px;
            }
            .lf.active{background-position: left bottom;}
            .lr.active{background-position: right bottom;}
        }
    }
}
</style>